import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {catchError, filter, switchMap, take} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../core/auth.service';
import {EMPTY, Observable, Subject} from 'rxjs';
import {WSError} from '../core/socket/socket.service';

@Component({
    selector: 'sam4-google-authorization',
    templateUrl: './google-authorization.component.html',
    styleUrls: ['./google-authorization.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GoogleAuthorizationComponent implements OnInit {
    private error$$: Subject<WSError> = new Subject<WSError>();
    public error$: Observable<WSError> = this.error$$.asObservable();

    constructor(private route: ActivatedRoute, private auth: AuthService) {
        // check google auth
        this.route.queryParamMap.pipe(
            filter(queryParams => {
                // not sure if scope is really needed
                return queryParams.has('code') && queryParams.has('scope');
            }),
            switchMap(queryParams => {
                return this.auth.googleLogin$(queryParams.get('code') as string);
            }),
            catchError(err => {
                this.error$$.next(err);
                return EMPTY;
            }),
            take(1)
        ).subscribe();
    }

    ngOnInit(): void {
    }

}
